import { SelectOption } from '../types';
import { GroupTypeBase, Styles } from 'react-select'
import Select from 'common/components/select/Select';

interface Props {
  onChange: (value: any) => void;
  value?: SelectOption;
  options: readonly SelectOption[];
  placeholder?: string;
  name?: string;  
  styles?: Partial<Styles<SelectOption, false, GroupTypeBase<SelectOption>>>;
  isRequired?: boolean;
}


export const MatchColumnSelect = ({ onChange, value, options, placeholder, styles, name, isRequired = false }: Props) => {
  return (
      <Select
        options={options}
        isClearable={true}
        rules={{ required: isRequired }}
        value={value}
        usePortal
        placeholder={placeholder}
        onChange={onChange}
        styles={{
          ...styles,
          menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
        }}
      />
  );
};
